export const LEFT = 'left';
export const RIGHT = 'right';
export const FRONT = 'front';
export const BACK = 'back';
export const TOP = 'top';
export const FRONT_LEFT = 'frontLeft';
export const FRONT_RIGHT = 'frontRight';
